import html2canvas from "html2canvas";
import { saveAs } from 'file-saver';
import { authHeader } from "../../../javascript/auth-header";
import { getVintageFromReportType } from "../../Common/Helpers";

export async function deleteEmployeeReportImage(fileName, state, props) {
    var currentDateTime = state.currentDateTime;
    var display_id = props.UserState.report_display_id;

    let url = "/IRISReportsMicroservice/api/PDF/NewEmployeeReportPDF/delete_image";

    var obj = {};

    obj["display_id"] = display_id;
    obj["currentDateTime"] = currentDateTime;
    obj["imageName"] = fileName;
    obj["vintage"] = getVintageFromReportType("employee-report", props.UserState);
    var headers = authHeader();
    headers.append('Accept', 'application/json'); // This one is enough for GET requests
    headers.append('Content-Type', 'application/json'); // This one sends body
    fetch(url, { method: 'POST', body: JSON.stringify(obj), headers: headers })
}

export const exportEmployeeReportImage = (
    divName,
    imageName,
    NewEmployeeReportState,
    report_display_id,
    currentDateTime,
    exportYesNo,
    vintage
) => {
    const yello = document.querySelector(divName);
    
    html2canvas(yello).then(canvas => {
        //var a = document.createElement('a');
        const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
            const byteCharacters = atob(b64Data);
            const byteArrays = [];

            for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                const slice = byteCharacters.slice(offset, offset + sliceSize);

                const byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                const byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
            }

            const blob = new Blob(byteArrays, { type: contentType });
            return blob;
        }

        let dataURL = canvas.toDataURL("image/png");
        const blob = b64toBlob(dataURL.substring(22), "image/png");
        var university = NewEmployeeReportState.EmployeeProfileInfo.university;
        var start_year = NewEmployeeReportState.EmployeeMethodology.start_year;
        var end_year = NewEmployeeReportState.EmployeeMethodology.end_year;
        var employeeRelease = NewEmployeeReportState.employeeRelease;
        
        let form = new FormData();
        form.append('image', blob, imageName);
        form.append("display_id", report_display_id);
        form.append("currentDateTime", currentDateTime);
        form.append("vintage", vintage);

        form.append("university", university);
        form.append("start_year", start_year);
        form.append("end_year", end_year);
        form.append("employeeRelease", employeeRelease);
        
        var headers = authHeader();
        let url = "/IRISReportsMicroservice/api/PDF/NewEmployeeReportPDF/send_image";


        fetch(url, { method: 'POST', body: form, headers: headers }).then(res => {
            return res.blob();
        })
            .then(blob => {
                if (exportYesNo == "yes")
                    saveAs(blob, imageName);
            }).catch((error) => {
                console.log(error);
            })
    })


}